import {Badge} from "../../../basic/badge.tsx";
import {Building2} from "lucide-react";
import {useTranslationWithKeys} from "../../../../hooks/useTranslationWithKeys";
import {ColumnDef, DataTable} from "../../../shared/tables/DataTable.tsx";
import {VwpTeam} from "../../../../store/generated/api.ts";
import {formatDate} from "../../../../utils/dateUtils.ts";
import {getTeamDisplayName} from "../../../../utils/teamUtils.ts";

interface TeamTableProps {
    teams: VwpTeam[];
    onTeamClick: (teamId: string) => void;
}

export function TeamTable({teams, onTeamClick}: TeamTableProps) {
    const {t} = useTranslationWithKeys();

    const columns: ColumnDef<VwpTeam>[] = [
        {
            key: "name",
            header: t('admin.teams.table.teamName'),
            cell: (team) => (
                <div className="flex items-center gap-2">
                    <Building2 className="h-4 w-4 text-muted-foreground"/>
                    {getTeamDisplayName({
                        teamName: team.name,
                        firstName: team.adminName?.split(' ')[0],
                        lastName: team.adminName?.split(' ').slice(1).join(' ')
                    }) ?? t('common.noTeam')}
                </div>
            )
        },
        {
            key: "members",
            header: t('admin.teams.table.members')
        },
        {
            key: "totalLicenses",
            header: t('admin.teams.table.totalLicenses')
        },
        {
            key: "createdDate",
            header: t('admin.teams.table.created'),
            cell: (team) => formatDate(team.createdDate)
        },
        {
            key: "status",
            header: t('admin.teams.table.status'),
            cell: (team) => (
                <Badge variant={team.status === "ACTIVE" ? "default" : "secondary"}>
                    {team.status}
                </Badge>
            )
        }
    ];

    return (
        <DataTable
            data={teams}
            columns={columns}
            onRowClick={(team) => onTeamClick(team.id)}
            withBorder={false}
        />
    );
}